import React, {useState} from 'react';
import {Image} from "react-bootstrap"; // Optional for custom styling
import dashboardImage from "../../../assets/img/bimi-screenshot.webp";
import {useTranslation} from "react-i18next";
import baseHostname from "../../../hostname"; // Optional for custom styling
import {useDispatch} from 'react-redux';
import {useNavigate} from "react-router-dom";


export const BimiChecker = () => {
    const [domain, setDomain] = useState('');
    const [result, setResult] = useState('');
    const [loading, setLoading] = useState(false);
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate(); // Hook for programmatic navigation

    const fetchDmarcRecord = async (e) => {
        e.preventDefault();
        setResult('');
        setLoading(true);

        fetch(
            baseHostname + '/index.php/domain/analyze',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(
                    {
                        source: "BIMI",
                        domain: domain,
                    }
                )
            }
        )
            .then(response => {
                if (!response.ok) {
                    console.warn('Server returned an error:', response.status);
                    return null;
                }
                return response.json();
            })
            .then(data => {
                if (data) {
                    // Save the DMARC validation result into Redux
                    dispatch({type: 'SET_BIMI_ANALYZE_RESULT', payload: data});
                    // Redirect to the results page
                    navigate('/bimi/result');
                }
            })
            .catch(error => {
                console.error('Error during API call:', error);
            });

    };

    return (
        <>
            {/*<article>*/}
            {/*    <title>{t('pages.home.meta.title')}</title>*/}
            {/*    <meta name={"description"} content={t('pages.home.meta.description')}></meta>*/}
            {/*    <link rel={"alternate"} hrefLang={"en"} href={"/en"}/>*/}
            {/*    <link rel={"alternate"} hrefLang={"de"} href={"/de"}/>*/}
            {/*    <link rel={"alternate"} hrefLang={"x-default"} href={"/en"}/>*/}
            {/*</article>*/}

            <div className="container-fluid">
                <div className={"row pt-5"} style={{backgroundColor: "#F5F7FF"}}>
                    <div className="col-12">
                        <header className="mb-5 text-center px-3">
                            <h1>{t("pages.bimiChecker.lookup.title")}</h1>
                            <p className="lead">{t("pages.bimiChecker.lookup.subTitle")}</p>
                        </header>
                    </div>
                </div>
                <div className={"row d-flex justify-content-center pb-5"} style={{backgroundColor: "#F5F7FF"}}>
                    <div className="col-12 col-md-10 col-lg-8 px-4 px-md-2">
                        <form onSubmit={fetchDmarcRecord}
                              className="mb-4 bg-white p-4 p-md-5 rounded rounded-3 shadow d-flex flex-column">
                            <label htmlFor="domain">{t("pages.bimiChecker.lookup.form.title")}</label>
                            <input
                                id="domain"
                                className="form-control my-2"
                                placeholder="e.g. example.com"
                                value={domain}
                                onChange={(e) => setDomain(e.target.value)}
                                required
                            />
                            <button className="btn btn-primary text-white align-self-end mt-3" type="submit"
                                    disabled={loading}>
                                {loading ? t("pages.bimiChecker.lookup.form.checking") : t("pages.bimiChecker.lookup.form.check")}
                            </button>
                        </form>
                        {result && (
                            <div className="alert alert-info">
                                <strong>Result:</strong>
                                <pre className="mb-0">{result}</pre>
                            </div>
                        )}
                    </div>
                </div>
                <div className={"row d-flex justify-content-center pt-5 pb-5"} style={{backgroundColor: "#FEFEFF"}}>
                    <div className="col-12 col-md-10 col-lg-5 p-4 p-lg-5">
                        <h4>{t("pages.bimiChecker.dashboard.title")} </h4>
                        <div className={"container-fluid p-0"}>
                            <div className={"row"}>
                                <div className={"col"}>
                                    <p> {t("pages.bimiChecker.dashboard.body1")}</p>
                                </div>
                            </div>
                            <div className={"row"}>
                                <div className={"col"}>
                                    <p> {t("pages.bimiChecker.dashboard.body2")}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-10 col-lg-5 d-flex align-items-center justify-content-center px-4">
                        <Image src={dashboardImage} alt={"dashboard"} className={"img-fluid rounded rounded-1"}></Image>
                    </div>
                </div>

                {/* FAQ Section */}
                <div className="row justify-content-center pt-5 pb-5 text-center" style={{backgroundColor: "#F4F7FF"}}>
                    <div className="col-12 col-md-10 col-lg-6 px-4">
                        <h3>{t("pages.bimiChecker.bimiFaq.title")}</h3>
                        <span className="d-block mb-4">{t("pages.bimiChecker.bimiFaq.subTitle")}</span>

                        <div className="accordion mt-4 text-start" id="faqAccordionOne">
                            {/* FAQ Item 1 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingOne">
                                    <button
                                        className="accordion-button"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseOne"
                                        aria-expanded="true"
                                        aria-controls="collapseOne"
                                    >
                                        {t("pages.bimiChecker.bimiFaq.list.one.question")}
                                    </button>
                                </h2>
                                <div
                                    id="collapseOne"
                                    className="accordion-collapse collapse show"
                                    aria-labelledby="headingOne"
                                    data-bs-parent="#faqAccordionOne"
                                >
                                    <div
                                        className="accordion-body"
                                        dangerouslySetInnerHTML={{
                                            __html: t("pages.bimiChecker.bimiFaq.list.one.answer"),
                                        }}
                                    />
                                </div>
                            </div>

                            {/* FAQ Item 2 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingTwo">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseTwo"
                                        aria-expanded="false"
                                        aria-controls="collapseTwo"
                                    >
                                        {t("pages.bimiChecker.bimiFaq.list.two.question")}
                                    </button>
                                </h2>
                                <div
                                    id="collapseTwo"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingTwo"
                                    data-bs-parent="#faqAccordionTwo"
                                >
                                    <div className="accordion-body">
                                        {t("pages.bimiChecker.bimiFaq.list.two.answer")}
                                    </div>
                                </div>
                            </div>
                            {/* FAQ Item 3 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingThree">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseThree"
                                        aria-expanded="false"
                                        aria-controls="collapseThree"
                                    >
                                        {t("pages.bimiChecker.bimiFaq.list.three.question")}
                                    </button>
                                </h2>
                                <div
                                    id="collapseThree"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingThree"
                                    data-bs-parent="#faqAccordionThree"
                                >
                                    <div className="accordion-body">
                                        {t("pages.bimiChecker.bimiFaq.list.three.answer")}
                                    </div>
                                </div>
                            </div>
                            {/* FAQ Item 4 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingFour">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseFour"
                                        aria-expanded="false"
                                        aria-controls="collapseFour"
                                    >
                                        {t("pages.bimiChecker.bimiFaq.list.four.question")}
                                    </button>
                                </h2>
                                <div
                                    id="collapseFour"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingFour"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        {t("pages.bimiChecker.bimiFaq.list.four.answer")}
                                    </div>
                                </div>
                            </div>
                            {/* FAQ Item 5 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingFive">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseFive"
                                        aria-expanded="false"
                                        aria-controls="collapseFive"
                                    >
                                        {t("pages.bimiChecker.bimiFaq.list.five.question")}
                                    </button>
                                </h2>
                                <div
                                    id="collapseFive"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingFive"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        {t("pages.bimiChecker.bimiFaq.list.five.answer")}
                                    </div>
                                </div>
                            </div>
                            {/* FAQ Item 6 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingSix">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseSix"
                                        aria-expanded="false"
                                        aria-controls="collapseSix"
                                    >
                                        {t("pages.bimiChecker.bimiFaq.list.six.question")}
                                    </button>
                                </h2>
                                <div
                                    id="collapseSix"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingSix"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        {t("pages.bimiChecker.bimiFaq.list.six.answer")}
                                    </div>
                                </div>
                            </div>
                            {/* FAQ Item 7 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingSeven">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseSeven"
                                        aria-expanded="false"
                                        aria-controls="collapseSeven"
                                    >
                                        {t("pages.bimiChecker.bimiFaq.list.seven.question")}
                                    </button>
                                </h2>
                                <div
                                    id="collapseSeven"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingSeven"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        {t("pages.bimiChecker.bimiFaq.list.seven.answer")}
                                    </div>
                                </div>
                            </div>
                            {/* FAQ Item 8 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingEight">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseEight"
                                        aria-expanded="false"
                                        aria-controls="collapseEight"
                                    >
                                        {t("pages.bimiChecker.bimiFaq.list.eight.question")}
                                    </button>
                                </h2>
                                <div
                                    id="collapseEight"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingEight"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        {t("pages.bimiChecker.bimiFaq.list.eight.answer")}
                                    </div>
                                </div>
                            </div>
                            {/* FAQ Item 9 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingNine">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseNine"
                                        aria-expanded="false"
                                        aria-controls="collapseNine"
                                    >
                                        {t("pages.bimiChecker.bimiFaq.list.nine.question")}
                                    </button>
                                </h2>
                                <div
                                    id="collapseNine"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingNine"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        {t("pages.bimiChecker.bimiFaq.list.nine.answer")}
                                    </div>
                                </div>
                            </div>
                            {/* FAQ Item 10 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingTen">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseTen"
                                        aria-expanded="false"
                                        aria-controls="collapseTen"
                                    >
                                        {t("pages.bimiChecker.bimiFaq.list.ten.question")}
                                    </button>
                                </h2>
                                <div
                                    id="collapseTen"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingTen"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        {t("pages.bimiChecker.bimiFaq.list.ten.answer")}
                                    </div>
                                </div>
                            </div>
                            {/* FAQ Item 11 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingEleven">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseEleven"
                                        aria-expanded="false"
                                        aria-controls="collapseEleven"
                                    >
                                        {t("pages.bimiChecker.bimiFaq.list.eleven.question")}
                                    </button>
                                </h2>
                                <div
                                    id="collapseEleven"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingEleven"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        {t("pages.bimiChecker.bimiFaq.list.eleven.answer")}
                                    </div>
                                </div>
                            </div>
                            {/* FAQ Item 12 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingTwelve">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseTwelve"
                                        aria-expanded="false"
                                        aria-controls="collapseTwelve"
                                    >
                                        {t("pages.bimiChecker.bimiFaq.list.twelve.question")}
                                    </button>
                                </h2>
                                <div
                                    id="collapseTwelve"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingTwelve"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        {t("pages.bimiChecker.bimiFaq.list.twelve.answer")}
                                    </div>
                                </div>
                            </div>
                            {/* FAQ Item 13 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingThirteen">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseThirteen"
                                        aria-expanded="false"
                                        aria-controls="collapseThirteen"
                                    >
                                        {t("pages.bimiChecker.bimiFaq.list.thirteen.question")}
                                    </button>
                                </h2>
                                <div
                                    id="collapseThirteen"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingThirteen"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        {t("pages.bimiChecker.bimiFaq.list.thirteen.answer")}
                                    </div>
                                </div>
                            </div>
                            {/* FAQ Item 14 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingFourteen">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseFourteen"
                                        aria-expanded="false"
                                        aria-controls="collapseFourteen"
                                    >
                                        {t("pages.bimiChecker.bimiFaq.list.fourteen.question")}
                                    </button>
                                </h2>
                                <div
                                    id="collapseFourteen"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingFourteen"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        {t("pages.bimiChecker.bimiFaq.list.fourteen.answer")}
                                    </div>
                                </div>
                            </div>
                            {/* FAQ Item 15 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingFifteen">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseFifteen"
                                        aria-expanded="false"
                                        aria-controls="collapseFifteen"
                                    >
                                        {t("pages.bimiChecker.bimiFaq.list.fifteen.question")}
                                    </button>
                                </h2>
                                <div
                                    id="collapseFifteen"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingFifteen"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        {t("pages.bimiChecker.bimiFaq.list.fifteen.answer")}
                                    </div>
                                </div>
                            </div>
                            {/* FAQ Item 16 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingSixteen">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseSixteen"
                                        aria-expanded="false"
                                        aria-controls="collapseSixteen"
                                    >
                                        {t("pages.bimiChecker.bimiFaq.list.sixteen.question")}
                                    </button>
                                </h2>
                                <div
                                    id="collapseSixteen"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingSixteen"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        {t("pages.bimiChecker.bimiFaq.list.sixteen.answer")}
                                    </div>
                                </div>
                            </div>
                            {/* FAQ Item 17 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingSeventeen">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseSeventeen"
                                        aria-expanded="false"
                                        aria-controls="collapseSeventeen"
                                    >
                                        {t("pages.bimiChecker.bimiFaq.list.seventeen.question")}
                                    </button>
                                </h2>
                                <div
                                    id="collapseSeventeen"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingSeventeen"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        {t("pages.bimiChecker.bimiFaq.list.seventeen.answer")}
                                    </div>
                                </div>
                            </div>
                            {/* FAQ Item 18 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingEighteen">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseEighteen"
                                        aria-expanded="false"
                                        aria-controls="collapseEighteen"
                                    >
                                        {t("pages.bimiChecker.bimiFaq.list.eighteen.question")}
                                    </button>
                                </h2>
                                <div
                                    id="collapseEighteen"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingEighteen"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        {t("pages.bimiChecker.bimiFaq.list.eighteen.answer")}
                                    </div>
                                </div>
                            </div>
                            {/* FAQ Item 19 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingNineteen">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseNineteen"
                                        aria-expanded="false"
                                        aria-controls="collapseNineteen"
                                    >
                                        {t("pages.bimiChecker.bimiFaq.list.nineteen.question")}
                                    </button>
                                </h2>
                                <div
                                    id="collapseNineteen"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="headingNineteen"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        {t("pages.bimiChecker.bimiFaq.list.nineteen.answer")}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
};
